import { Reducer } from 'redux';

import {
  ActiveCall,
  CallsAction,
  CallsActionTypes,
  CallsStore,
  TERMINAL_CALL_STATUSES,
} from './callsTypes';

const initialState: CallsStore = {
  incomingCall: null,
  lastStatus: null,
  activeCall: null,
};

const callsReducer: Reducer<CallsStore, CallsAction> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case CallsActionTypes.SET_INCOMING_CALL:
      return { ...state, incomingCall: action.payload };
    case CallsActionTypes.CLEAR_INCOMING_CALL:
      return { ...state, incomingCall: null };
    case CallsActionTypes.SET_CALL_STATUS: {
      const update = action.payload;
      const terminal = TERMINAL_CALL_STATUSES.includes(update.status);
      // A terminal status for the ringing call clears the incoming-call prompt.
      const clearsIncoming =
        state.incomingCall?.callId === update.callId && terminal;
      // A terminal status for the active call tears the call UI down; an
      // IN_PROGRESS promotes a ringing outgoing call to in_call.
      let activeCall = state.activeCall;
      if (activeCall && activeCall.callId === update.callId) {
        if (terminal)
          activeCall = {
            ...activeCall,
            phase: 'ended',
            endReason: update.status,
          };
        else if (update.status === 'IN_PROGRESS')
          activeCall = { ...activeCall, phase: 'in_call' };
      }
      return {
        ...state,
        lastStatus: update,
        incomingCall: clearsIncoming ? null : state.incomingCall,
        activeCall,
      };
    }
    case CallsActionTypes.REQUEST_OUTGOING_CALL: {
      const activeCall: ActiveCall = {
        direction: 'outgoing',
        phase: 'requesting',
        peerCustomerId: action.payload.peerCustomerId,
        peerName: action.payload.peerName,
        callId: null,
        chatId: null,
        janusUrl: null,
        roomId: null,
        token: null,
        endReason: null,
      };
      return { ...state, activeCall };
    }
    case CallsActionTypes.ACCEPT_INCOMING_CALL: {
      const incoming = state.incomingCall;
      if (!incoming) return state;
      const activeCall: ActiveCall = {
        direction: 'incoming',
        phase: 'connecting',
        peerCustomerId: incoming.callerCustomerId,
        peerName: action.payload.peerName,
        callId: incoming.callId,
        chatId: incoming.chatId,
        janusUrl: incoming.janusUrl,
        roomId: incoming.roomId,
        token: incoming.token,
        endReason: null,
      };
      return { ...state, activeCall, incomingCall: null };
    }
    case CallsActionTypes.SET_ACTIVE_CALL_CREDS: {
      if (!state.activeCall) return state;
      return {
        ...state,
        activeCall: {
          ...state.activeCall,
          ...action.payload,
          phase: 'ringing',
        },
      };
    }
    case CallsActionTypes.SET_ACTIVE_CALL_PHASE: {
      if (!state.activeCall) return state;
      return {
        ...state,
        activeCall: { ...state.activeCall, phase: action.payload.phase },
      };
    }
    case CallsActionTypes.END_ACTIVE_CALL:
      return { ...state, activeCall: null };
    default:
      return state;
  }
};

export default callsReducer;
